import { useEffect } from "react";
import { useFieldArray, useWatch } from "react-hook-form";

const PackageForm = ({ t, control, register, errors, trigger }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "packages",
  });
  const packagesWatch = useWatch({
    control,
    name: "packages",
  });
  // Add new package
  const handleAdd = () => {
    append({
      nameEn: "",
      nameAr: "",
      offer: "",
      isActive: true,
      cost: "",
      unit: "", //0=days 1=hours
      unitNumber: "", //number of days or hours
      description: "",
      descriptionEn: "",
      isSpecial: false,
      startDate: "", // if the package is special e.g. festival or even we should add the start date for this package
      endDate: "", // if the package is special e.g. festival or even we should add the end date for this package
    });
  };
  return (
    <div className="my-card mt-3">
      <div className="my-card-header text-primary">{t("tripPackages")}</div>
      <div className="my-card-body">
        {fields?.map((item, index) => {
          const isSpecial = packagesWatch?.[index]?.isSpecial;
          return (
            <div className="my-card mt-3" key={index}>
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="form-label">{t("name")}</label>
                    <input
                      type="text"
                      {...register(`packages.${index}.nameAr`)}
                      className="form-control"
                      placeholder={t("name")}
                    />
                    <p className="text-danger">
                      {errors?.packages?.[index]?.nameAr?.message}
                    </p>
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="form-label">{t("nameEn")}</label>
                    <input
                      type="text"
                      {...register(`packages.${index}.nameEn`)}
                      className="form-control"
                      placeholder={t("nameEn")}
                    />
                    <p className="text-danger">
                      {errors?.packages?.[index]?.nameEn?.message}
                    </p>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="form-label">{t("cost")}</label>
                    <input
                      type="number"
                      {...register(`packages.${index}.cost`)}
                      className="form-control"
                      placeholder={t("cost")}
                    />
                    <p className="text-danger">
                      {errors?.packages?.[index]?.cost?.message}
                    </p>
                  </div>
                </div>
                 <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="form-label">{t("discount")} (%)</label>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      {...register(`packages.${index}.offer`)}
                      className="form-control"
                      placeholder={t("discount")}
                    />
                    <p className="text-danger">
                      {errors?.packages?.[index]?.offer?.message}
                    </p>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="form-label">{t("unit")}</label>
                    <select
                      className="form-control"
                      {...register(`packages.${index}.unit`)}
                    >
                      <option value="">--{t("unit")}--</option>
                      <option value={0}>{t("days")}</option>
                      <option value={1}>{t("hours")}</option>
                    </select>
                    <p className="text-danger">
                      {errors?.packages?.[index]?.unit?.message}
                    </p>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="form-label">{t("unitNumber")}</label>
                    <input
                      type="number"
                      {...register(`packages.${index}.unitNumber`)}
                      className="form-control"
                      placeholder={t("unitNumber")}
                    />
                    <p className="text-danger">
                      {errors?.packages?.[index]?.unitNumber?.message}
                    </p>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group d-flex gap-1 align-items-center">
                    <input
                      type="checkbox"
                      {...register(`packages.${index}.isSpecial`)}
                    />
                    <label>{t("specialTrip")}</label>
                  </div>
                </div>
                 <div className="col-6">
                  <div className="form-group d-flex gap-1 align-items-center">
                    <input
                      type="checkbox"
                      {...register(`packages.${index}.isActive`)}
                    />
                    <label>{t("active")}</label>
                  </div>
                </div>
                {isSpecial && (
                  <>
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="form-label">{t("startDate")}</label>
                        <input
                          type="date"
                          {...register(`packages.${index}.startDate`)}
                          className="form-control"
                        />
                        <p className="text-danger">
                          {errors?.packages?.[index]?.startDate?.message}
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="form-label">{t("endDate")}</label>
                        <input
                          type="date"
                          {...register(`packages.${index}.endDate`)}
                          className="form-control"
                        />
                        <p className="text-danger">
                          {errors?.packages?.[index]?.endDate?.message}
                        </p>
                      </div>
                    </div>
                  </>
                )}

                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="form-label">{t("description")}</label>
                    <textarea
                      type="text"
                      {...register(`packages.${index}.description`)}
                      className="form-control"
                      placeholder={t("description")}
                      rows={4}
                    />
                    <p className="text-danger">
                      {errors?.packages?.[index]?.description?.message}
                    </p>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="form-label">{t("descriptionEn")}</label>
                    <textarea
                      type="text"
                      {...register(`packages.${index}.descriptionEn`)}
                      className="form-control"
                      placeholder={t("descriptionEn")}
                      rows={4}
                    />
                    <p className="text-danger">
                      {errors?.packages?.[index]?.descriptionEn?.message}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {fields.length > 1 && (
          <div
            className="remove-btn mt-3"
            onClick={() => remove(fields.length - 1)}
          >
            <i className="fas fa-minus plus-icon"></i> {t("remove")}
          </div>
        )}
        <div className="add-btn mt-3" onClick={handleAdd}>
          <i className="fas fa-plus plus-icon"></i> {t("add")}
        </div>
      </div>
    </div>
  );
};
export default PackageForm;
